module.exports = __webpack_public_path__ + "459910d49befa856c91609966d56f7fb.svg";